// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form[data-v-ba1e9380] {
  display: flex;
  flex-direction: column;
}
form .header-text[data-v-ba1e9380] {
  color: var(--elem-grey-color);
  margin-bottom: 15px;
  font-size: 16px;
}
label.custom-radio[data-v-ba1e9380] {
  cursor: pointer;
  position: relative;
  text-indent: 30px;
  font-weight: normal;
  line-height: 20px;
  font-size: 15px;
}
label.custom-radio[data-v-ba1e9380]:not(:last-child) {
  margin-bottom: 17px;
}
label.custom-radio input[type='radio'][data-v-ba1e9380] {
  position: absolute;
  left: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  line-height: inherit;
  opacity: 0;
  margin: auto;
}
label.custom-radio input[type='radio'] + i[data-v-ba1e9380] {
  top: 1px;
  text-indent: 0;
  position: absolute;
  left: 0;
  font-size: 19px;
  color: var(--elem-grey-color);
  font-style: normal;
  font-weight: normal;
  line-height: inherit;
}
label.custom-radio input[type='radio']:checked + i[data-v-ba1e9380]::before {
  content: "\\f192";
  color: var(--modal-elem-color);
}
label.custom-radio .description[data-v-ba1e9380] {
  color: var(--elem-grey-color);
  font-size: 14px;
  text-indent: initial;
  padding-left: 30px;
}
.micOK[data-v-ba1e9380],
.isEnabled[data-v-ba1e9380] {
  opacity: 1;
}
.noMicrophone[data-v-ba1e9380],
.isDisabled[data-v-ba1e9380] {
  opacity: 0.4;
}
.horizontal[data-v-ba1e9380] {
  flex-direction: row;
  align-items: center;
}
.horizontal input[type='radio'] + i[data-v-ba1e9380] {
  font-size: 16px !important;
}
.horizontal label.custom-radio[data-v-ba1e9380] {
  font-size: 16px;
  margin-bottom: 0;
  margin-right: 30px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomRadio.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,SAAS;EACT,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;AACA;EACE,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["form[data-v-ba1e9380] {\n  display: flex;\n  flex-direction: column;\n}\nform .header-text[data-v-ba1e9380] {\n  color: var(--elem-grey-color);\n  margin-bottom: 15px;\n  font-size: 16px;\n}\nlabel.custom-radio[data-v-ba1e9380] {\n  cursor: pointer;\n  position: relative;\n  text-indent: 30px;\n  font-weight: normal;\n  line-height: 20px;\n  font-size: 15px;\n}\nlabel.custom-radio[data-v-ba1e9380]:not(:last-child) {\n  margin-bottom: 17px;\n}\nlabel.custom-radio input[type='radio'][data-v-ba1e9380] {\n  position: absolute;\n  left: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  line-height: inherit;\n  opacity: 0;\n  margin: auto;\n}\nlabel.custom-radio input[type='radio'] + i[data-v-ba1e9380] {\n  top: 1px;\n  text-indent: 0;\n  position: absolute;\n  left: 0;\n  font-size: 19px;\n  color: var(--elem-grey-color);\n  font-style: normal;\n  font-weight: normal;\n  line-height: inherit;\n}\nlabel.custom-radio input[type='radio']:checked + i[data-v-ba1e9380]::before {\n  content: \"\\f192\";\n  color: var(--modal-elem-color);\n}\nlabel.custom-radio .description[data-v-ba1e9380] {\n  color: var(--elem-grey-color);\n  font-size: 14px;\n  text-indent: initial;\n  padding-left: 30px;\n}\n.micOK[data-v-ba1e9380],\n.isEnabled[data-v-ba1e9380] {\n  opacity: 1;\n}\n.noMicrophone[data-v-ba1e9380],\n.isDisabled[data-v-ba1e9380] {\n  opacity: 0.4;\n}\n.horizontal[data-v-ba1e9380] {\n  flex-direction: row;\n  align-items: center;\n}\n.horizontal input[type='radio'] + i[data-v-ba1e9380] {\n  font-size: 16px !important;\n}\n.horizontal label.custom-radio[data-v-ba1e9380] {\n  font-size: 16px;\n  margin-bottom: 0;\n  margin-right: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
